import React, { useContext, useMemo } from 'react'

import { styled } from '@linaria/react'
import { Property } from 'csstype'

import { breakpoints } from 'components/designSystem/shared/breakpoints'

import {
  backgrounds as bigImages,
  backgroundsShadow as bigImagesShadow,
} from './assets/button/double/backgroundImages'
import {
  backgrounds as smallImage,
  backgroundsShadow as smallImageShadow,
} from './assets/button/single/backgroundImages'
import { ParentCommon } from './Buttons/buttons.styled'
import { Chat } from './Buttons/Chat'
import { Dislike } from './Buttons/Dislike'
import { Like } from './Buttons/Like'
import { UnionButtons } from './Buttons/UnionButtons'
import { isVoteable } from './function/isVoteable'
import { ProfileNextContext } from '../Profile/ProfileMain/context/ProfileNextContext'

export const Desktop = () => {
  const { place, voteable } = useContext(ProfileNextContext)
  const hasVoted = isVoteable(place, voteable)

  const { smallBackground, bigBackground } = useMemo(() => {
    return {
      smallBackground: `url(${smallImage[smallImage.length - 1]}), url(${
        smallImageShadow[smallImageShadow.length - 1]
      })`,
      bigBackground: `url(${bigImages[bigImages.length - 1]}), url(${
        bigImagesShadow[bigImagesShadow.length - 1]
      })`,
    }
  }, [])

  return (
    <Parent
      data-name="control-bar-desktop"
      $align={hasVoted ? 'space-between' : 'center'}
    >
      {place === 'rating' && (
        <Dislike
          style={{
            background: smallBackground,
          }}
        />
      )}
      <UnionButtons
        data-name="union-button"
        style={{
          background: bigBackground,
        }}
      >
        <Chat />
      </UnionButtons>
      {hasVoted && (
        <Like
          style={{
            backgroundImage: smallBackground,
          }}
        />
      )}
    </Parent>
  )
}

const Parent = styled(ParentCommon)<{
  $align: Property.JustifyContent
}>`
  display: grid;
  grid-auto-flow: column;
  justify-content: ${(props) => props.$align};
  align-items: center;

  @media screen and (max-width: ${breakpoints.mobile}px) {
    display: none;
  }
`
